module.exports = __webpack_public_path__ + "static/media/combank-logo.f319fe82.png";